import { Button, Icon, IconButton, TIconButtonProps, TranslationsDropdown } from '@guidde/design-system'
import { QuickGuiddeType } from 'app/types'

import { faGlobe } from '@fortawesome/pro-regular-svg-icons'

export type LanguageSwitcherProps = {
    playbook: QuickGuiddeType
    isRtl: boolean
    buttonStyling: {
        size: TIconButtonProps['size']['size']
        isIconButton: boolean
        iconSize: number
    }
    onLanguageChange: (_: string) => void
}

export const LanguageSwitcher = ({ playbook, onLanguageChange, buttonStyling, isRtl }: LanguageSwitcherProps) => {
    const translations = playbook.primaryPlaybook?.translations || playbook.translations || []
    const hasMultipleTranslations = translations.length > 1

    if (!hasMultipleTranslations) return null

    const icon = (
        <Icon
            icon={faGlobe}
            style={{
                width: buttonStyling.iconSize,
                height: buttonStyling.iconSize,
            }}
        />
    )

    return (
        <TranslationsDropdown
            translations={translations}
            onMenuItemSelect={({ language }) => onLanguageChange(language.langCode)}
            selectedTranslationId={playbook.language.langCode}
            hasOptionCheckIcon
            isDisabled={false}
            shouldShowPrimaryBadge={false}
            shouldCloseOnSelect
            placement="bottom-end"
            zIndex={1000}
            dropdownMaxHeight="234px"
        >
            {buttonStyling.isIconButton ? (
                <IconButton
                    size={buttonStyling.size}
                    label="switch language"
                    variant="outlined"
                    isCircled
                    color="secondary"
                >
                    {icon}
                </IconButton>
            ) : (
                <Button
                    size={buttonStyling.size}
                    variant="outlined"
                    color="secondary"
                >
                    {icon}
                    <span
                        style={{
                            marginLeft: !isRtl ? '5px' : '0',
                            marginRight: isRtl ? '5px' : '0',
                        }}
                    >
                        {playbook.language.langCode.slice(0, 2).toUpperCase()}
                    </span>
                </Button>
            )}
        </TranslationsDropdown>
    )
}
